import React, { useCallback } from 'react';
import type { BagProtectionForm } from '~/@types/BagProtection/form';
import { AddressInfoInput } from '~/components';
import type { StepComponentProps } from '~/components/StepsForm';
import useBagProtectionForm from '~/stores/bagProtectionForm';

const BagProtectionContractAddress: React.FC<StepComponentProps> = ({
  onContinue,
}) => {
  const { setAddress } = useBagProtectionForm();

  const onValidate = useCallback(
    (data: BagProtectionForm.Address) => {
      setAddress(data);
      onContinue?.();
    },
    [onContinue, setAddress]
  );

  return (
    <AddressInfoInput insuranceType="bag-protection" onValidate={onValidate} />
  );
};

export default BagProtectionContractAddress;
